import { render, staticRenderFns } from "./FolderBlock.vue?vue&type=template&id=781df21e"
import script from "./FolderBlock.vue?vue&type=script&lang=js"
export * from "./FolderBlock.vue?vue&type=script&lang=js"
import style0 from "./FolderBlock.vue?vue&type=style&index=0&id=781df21e&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports